import { toast } from 'sonner';

// Toasts standardisés :
// - Texte court
// - Option d'action (label + callback)
// - Durée par défaut cohérente

function buildToastOptions(opts = {}) {
  const { duration, actionLabel, onAction, description, ...rest } = opts || {};

  const action = actionLabel && typeof onAction === 'function'
    ? { label: actionLabel, onClick: onAction }
    : undefined;

  const base = {
    duration: typeof duration === 'number' ? duration : 3400,
    ...(description ? { description } : {}),
    ...(action ? { action } : {}),
  };

  return { ...base, ...rest };
}

export function notifySuccess(message, opts) {
  return toast.success(message, buildToastOptions(opts));
}

export function notifyError(message, opts) {
  return toast.error(message, buildToastOptions(opts));
}

export function notifyInfo(message, opts) {
  return toast(message, buildToastOptions(opts));
}
